/**
 * @author kkakkuro0
 * @date 2024.10.08
 * @description 상품 카드
 */

import { useCallback } from 'react';
import { formatNumberWithComma, getDiscountRate } from '../../../../util/util';
import { useNavigate } from 'react-router-dom';
import { IProduct } from '../../../../store/useProduct';
import LazyImage from '../../../form/LazyImage';

const ProductCard = ({
  id,
  productName,
  price,
  discountPrice,
  thumbnailFile,
}: IProduct) => {
  const navigate = useNavigate();
  const moveToProductDetail = useCallback(
    () => navigate(`/product/${id}`),
    [navigate, id]
  );
  return (
    <div className="!bg-white !rounded-lg !overflow-hidden !cursor-pointer !transition-all !duration-200 !ease-in-out !border !border-gray-200 hover:!shadow-lg hover:!border-gray-300 !group" onClick={moveToProductDetail}>
      <div className="!w-full !pt-[100%] !relative !overflow-hidden !bg-gray-100">
        <LazyImage
          src={thumbnailFile.fileFullUrl}
          alt="saju_product_img"
          className="!absolute !top-0 !left-0 !w-full !h-full !object-cover !transition-transform !duration-300 group-hover:!scale-105"
          skeleton="!absolute !top-0 !left-0 !w-full !h-full !bg-gradient-to-r !from-gray-200 !via-gray-100 !to-gray-200 !animate-pulse"
        />
      </div>
      <div className="!p-4">
        <h3 className="!text-[15px] !font-normal !leading-[22px] !text-gray-800 !mb-2 !line-clamp-2 !min-h-[44px]">{productName}</h3>
        <div className="!flex !items-center !gap-2 !flex-wrap">
          {!!discountPrice && (
            <>
              <span className="!text-gray-500 !line-through !text-sm !font-normal">
                {formatNumberWithComma(price)}원
              </span>
              <span className="!text-lg !font-bold !text-gray-900">
                {formatNumberWithComma(discountPrice)}원
              </span>
              <span className="!font-semibold !text-red-500 !text-sm">
                {getDiscountRate(discountPrice, price)}%
              </span>
            </>
          )}
          {!discountPrice && (
            <span className="!text-lg !font-bold !text-gray-900">
              {formatNumberWithComma(price)}원
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
